import {Component, Input, OnInit} from '@angular/core';
import {PaymentTransactionModel} from '../../../models/contract.model';
import {FinanceService} from '../../../services/api/finance.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberModel} from '../../../models/user.model';

@Component({
    selector: 'app-payment-modal',
    templateUrl: './payment-modal.component.html',
    styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalComponent implements OnInit {

    @Input() public paymentGuid: string;
    @Input() public detail = true;
    @Input() public contractView = true;
    @Input() public multiPaymentInfo: any;
    @Input() public payments: PaymentTransactionModel[];

    public paymentsSlide: any = [];

    paymentInfo: PaymentTransactionModel;
    signedMember: any;
    paymentError = false;

    isLoading = true;

    @Input() public walletProjectGuid: string;

    constructor(
        protected finance: FinanceService,
        public helper: HelpersService
    ) {
    }

    ngOnInit(): void {
        if (this.detail) {
            if (!this.multiPaymentInfo) {
                this.finance.getPayment(this.paymentGuid).subscribe(payment => {
                    this.paymentInfo = payment.transaction;
                    this.isLoading = false;
                    this.paymentInfo.payer.name = this.paymentInfo.payer.name || this.helper.fullName(this.paymentInfo.payer as unknown as MemberModel)
                    this.paymentInfo.recipient.name = this.paymentInfo.recipient.name || this.helper.fullName(this.paymentInfo.recipient as unknown as MemberModel)
                });
            } else {
                this.paymentInfo = this.multiPaymentInfo.payment;
                this.signedMember = this.multiPaymentInfo.members;
                this.isLoading = false;
            }
        } else {
            this.isLoading = false;
        }
    }

    statusConstructor(payment: PaymentTransactionModel): string {
        let status: string;
        switch (payment.payment_status) {
            case 'NEW':
                status = 'INITIATED';
                return status;

            case 'PROMISED':
                status = 'WORK';
                return status;

            case 'APPROVED':
                status = 'APPROVED';
                return status;

            case 'EXECUTION':
                status = 'WORK';
                return status;

            case 'SUCCESS':
                status = 'SUCCESS';
                return status;
            default:
                status = 'CANCELED';
                this.paymentError = true;
                return status;
        }
    }

}
